const AUTH_CONFIG = {
  local: {
    client_id: '950be5bc-4092-4b4c-9a80-108100c29fc8',
    redirect_uri: 'http://localhost:3000/callback',
    response_type: 'code',
    scope:
      'openid offline_access https://rclistai.onmicrosoft.com/950be5bc-4092-4b4c-9a80-108100c29fc8/access_api',
    loadUserInfo: false,
    authority:
      'https://rclistai.b2clogin.com/9c8af4f1-6dee-4876-9a1e-27b6cb628fb6/v2.0/',
    metadata: {
      issuer:
        'https://rclistai.b2clogin.com/9c8af4f1-6dee-4876-9a1e-27b6cb628fb6/v2.0/',
      authorization_endpoint:
        'https://rclistai.b2clogin.com/rclistai.onmicrosoft.com/b2c_1a_signup_signin/oauth2/v2.0/authorize?usesso=true',
      token_endpoint:
        'https://rclistai.b2clogin.com/rclistai.onmicrosoft.com/b2c_1a_signup_signin/oauth2/v2.0/token',
    },
    settings: {
      instrumentationKey: 'eee93162-8c08-463e-8a0e-11dbaf9384da',
    },
  },
  dev: {
    client_id: '0925762b-5538-4582-bb1b-2eceb378a855',
    redirect_uri: 'https://wolf.rcgwd.iasp.tgscloud.net/callback',
    response_type: 'code',
    scope:
      'openid offline_access https://rclistad.onmicrosoft.com/0925762b-5538-4582-bb1b-2eceb378a855/access_api',
    loadUserInfo: false,
    authority:
      'https://rclistad.b2clogin.com/3aa739ac-626d-411f-8279-741e466a72b4/v2.0/',
    metadata: {
      issuer:
        'https://rclistad.b2clogin.com/3aa739ac-626d-411f-8279-741e466a72b4/v2.0/',
      authorization_endpoint:
        'https://rclistad.b2clogin.com/rclistad.onmicrosoft.com/b2c_1a_signup_signin/oauth2/v2.0/authorize?usesso=true',
      token_endpoint:
        'https://rclistad.b2clogin.com/rclistad.onmicrosoft.com/b2c_1a_signup_signin/oauth2/v2.0/token',
    },
    settings: {
      instrumentationKey: 'eee93162-8c08-463e-8a0e-11dbaf9384da',
    },
  },
  qa: {
    client_id: '950be5bc-4092-4b4c-9a80-108100c29fc8',
    redirect_uri: 'https://wolf.rcgwq.iasp.tgscloud.net/callback',
    response_type: 'code',
    scope:
      'openid offline_access https://rclistai.onmicrosoft.com/950be5bc-4092-4b4c-9a80-108100c29fc8/access_api',
    loadUserInfo: false,
    authority:
      'https://rclistai.b2clogin.com/9c8af4f1-6dee-4876-9a1e-27b6cb628fb6/v2.0/',
    metadata: {
      issuer:
        'https://rclistai.b2clogin.com/9c8af4f1-6dee-4876-9a1e-27b6cb628fb6/v2.0/',
      authorization_endpoint:
        'https://rclistai.b2clogin.com/rclistai.onmicrosoft.com/b2c_1a_signup_signin/oauth2/v2.0/authorize?usesso=true',
      token_endpoint:
        'https://rclistai.b2clogin.com/rclistai.onmicrosoft.com/b2c_1a_signup_signin/oauth2/v2.0/token',
    },
    settings: {
      instrumentationKey: 'e6579dcb-624e-4602-83d4-d47440389316',
    },
  },
  prod: {
    client_id: 'b2a02f51-0003-4321-a6e7-2ccdf11be443',
    redirect_uri: 'https://wolf.rcgwp.iasp.tgscloud.net/callback',
    response_type: 'code',
    scope:
      'openid offline_access https://rclistap.onmicrosoft.com/b2a02f51-0003-4321-a6e7-2ccdf11be443/access_api',
    loadUserInfo: false,
    authority:
      'https://rclistap.b2clogin.com/b90b14ea-db01-4f30-9c58-e5d62d5c7d68/v2.0/',
    metadata: {
      issuer:
        'https://rclistap.b2clogin.com/b90b14ea-db01-4f30-9c58-e5d62d5c7d68/v2.0/',
      authorization_endpoint:
        'https://rclistap.b2clogin.com/rclistap.onmicrosoft.com/b2c_1a_signup_signin/oauth2/v2.0/authorize?usesso=true',
      token_endpoint:
        'https://rclistap.b2clogin.com/rclistap.onmicrosoft.com/b2c_1a_signup_signin/oauth2/v2.0/token',
    },
    settings: {
      instrumentationKey: '15fcb2e0-0fa7-4f53-b646-07fb1efa3b2b',
    },
  },
};
export default AUTH_CONFIG;
